import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import { BodyRegular, Caption } from '../Typography/Typography';

const useStyles = makeStyles((theme: Theme) => {
  return {
    wrapper: {
      boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.1)',
      padding: '24px',
      borderRadius: '8px',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#FFF',
      alignItems: 'center',
      gap: '24px',
      [theme.breakpoints.up(1200)]: {
        flexDirection: 'row',
      }
    },
    icon: {
      display: 'block',
      width: '80px',
    },
    textWrapper: {
      flex: 1,
      justifyContent: 'space-between',
      display: 'flex',
      flexDirection: 'column',
    },
    footnote: {
      marginTop: '16px',
      marginBottom: 0,
      fontWeight: '700',
    },
  };
});

const TestimonialCard = ({ testimonialText, testimonialTitle }) => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <img className={classes.icon} src="/img/business-page/icon.svg" alt="" />
      <div>
        <BodyRegular>{testimonialText}</BodyRegular>
        <Caption className={classes.footnote}>{testimonialTitle}</Caption>
      </div>
    </div>
  );
};

export default TestimonialCard;
